import Default from './variants/Default';
import type {Props} from './types';

const Drop = (props: Props) => {
  return <Default {...props} />;
};

export default Drop;
